"use strict";
const IUserAuthenticationService_interface_1 = require("./interfaces/IUserAuthenticationService.interface");
const IUserAuthStateService_interface_1 = require("./interfaces/IUserAuthStateService.interface");
const UserAuthenticationService_service_1 = require("./testUserAuthenticationService/UserAuthenticationService.service");
const UserAuthState_service_1 = require("./userAuthState/UserAuthState.service");
exports.DEFAULT_USER_AUTH_SERVICE_PROVIDER_ENTRY = { provide: IUserAuthenticationService_interface_1.IUSERAUTHENTICATIONSERVICE_TOKEN, useClass: UserAuthenticationService_service_1.UserAuthenticationService, multi: false };
exports.DEFAULT_USER_AUTH_STATE_SERVICE_PROVIDER_ENTRY = { provide: IUserAuthStateService_interface_1.IUSERAUTHSTATESERVICE_TOKEN, useClass: UserAuthState_service_1.UserAuthStateService, multi: false };
exports.DEFAULT_USER_AUTHENTICATION_PROVIDER_ENTRIES = [
    exports.DEFAULT_USER_AUTH_SERVICE_PROVIDER_ENTRY,
    exports.DEFAULT_USER_AUTH_STATE_SERVICE_PROVIDER_ENTRY,
];
